import React, { useEffect } from "react";

import { withConfig } from "../../../../utils/withConfig";

import { useRouter } from "next/router";

import { initializeApollo, addApolloState } from "../../../../utils/appollo";
import { getSeoFields } from "../../../../utils/getSeoFields";
import { GET_CLUB_HEADER_DATA } from "../../../../graphql/queries/queriesClub";
import { getCommonClubData } from "../../../../utils/getCommonClubData";
import { scheduleViews } from "../../../../components/pagesComponents/Clubs/constants/constants";
import { getPropsDecorator } from "../../../../utils/getPropsDecorator";

const callback = async ({ locale, query: { club } }) => {
  const apolloClient = initializeApollo({ key: club, locale });

  const queries = [{ query: GET_CLUB_HEADER_DATA, variables: { showOffer: false } }];
  const promises = queries.map(({ query, variables }) => apolloClient.query({ query, variables }));

  await Promise.all(promises);

  const [{ data: { club: clubData = {} } = {} }] = await Promise.all(promises);

  const commonClubData = getCommonClubData(clubData);

  const pageProps = {
    props: {
      club,
      locale,
      scheduleDefaultView: scheduleViews[clubData.scheduleDefault] || scheduleViews[1],
      tags: getSeoFields({ ...commonClubData }),
      ...(await withConfig(locale)),
    },
  };

  return addApolloState(apolloClient, pageProps);
};

export const getServerSideProps = getPropsDecorator(callback);

const ScheduleMain = ({ club, scheduleDefaultView }) => {
  const router = useRouter();

  useEffect(() => {
    router.replace(`/club/${club}/schedule/${scheduleDefaultView}`);
  }, []);
  return <></>;
};

export default ScheduleMain;
